import React from "react";

import { Table } from "react-bootstrap";

import classNames from "classnames";

import customStyles from "./DetailListTable.module.scss";

interface DetailListTableProps<T> {
  data: T[];
  headers: { label: string; render: (row: T) => React.ReactNode }[];
  rowKey: (row: T) => string | number;
  emptyMessage?: string;
  className?: string;
  sortBy?: (a: T, b: T) => number;
}

export const DetailListTable = <T extends object>({
  data,
  headers,
  rowKey,
  emptyMessage = "No data available.",
  className,
  sortBy,
}: DetailListTableProps<T>) => {
  if (!data.length) {
    return <div>{emptyMessage}</div>;
  }
  const sortedData = sortBy ? [...data].sort(sortBy) : data;

  return (
    <Table className={classNames("mt-3", customStyles["table-bottom-border"], className)} hover>
      <tbody>
        {sortedData.map((row) => (
          <tr key={rowKey(row)}>
            {headers.map((header, index) => (
              <td key={header.label} className={classNames(customStyles[`column-${index}`])}>
                {header.render(row)}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </Table>
  );
};
